import * as React from 'react';
import { Spinner } from 'components';

require('./style.css');

interface IProps {
	isAuthenticated: any;
	signinRedirect: any;
	isLiked: boolean;
	shareText: string;
	likeItem: any;
	unlikeItem: any;
}

/**
 *
 * @param props
 */
export const ArticleMobileLikeButton = (props: IProps) => {
	let likeBtnContent: JSX.Element = null;
	if (props.isLiked === undefined || props.isLiked === null) {
		likeBtnContent = (
			<div style={{ textAlign: 'center' }}>
				<Spinner />
			</div>
		);
	} else if (!props.isLiked) {
		likeBtnContent = (
			<div className="articleMobileLikeButton">
				<a href="#" onClick={(e) => props.likeItem(e, props.isAuthenticated, props.signinRedirect)} className="like">
					<img className="icon" src={require('containers/Html/icons/components/likebutton/like-bw.svg')} />
					<div className="clear" />
				</a>
			</div>
		);
	} else {
		likeBtnContent = (
			<div className="articleMobileLikeButton isLiked">
				<a href="#" onClick={(e) => props.unlikeItem(e, props.isAuthenticated, props.signinRedirect)} className="like">
					<img className="icon" src={require('containers/Html/icons/components/likebutton/like-bw-liked.svg')} />
					<div className="clear" />
				</a>
			</div>
		);
	}

	return likeBtnContent;
};
